import React from 'react';
import ProductCardDetail from './product-card-detail';
import { Helpers } from '../../core/src/helpers';
import { withError } from '../../shared/components/error-boundary';
import ProductJsonLd from './product-json-ld';
import ProductCardFooter from './product-card-footer';
import ProductCardHeader from './product-card-header';
import ProductCardBundle from './product-card-bundle';
import '../css/product-card.less';

const ProductCard = ({ product, jumpInfo, className, saleCalloutPath, hideMktDiff, productIndex, productClickMetrics, ctaMetrics, popupConfig, baseProductSku, xsellType, templateKey, ...otherProps }) => {
    const { metadata = {}, attributes={} } = product;
    const { bundleComponents } = attributes;
    let urlParams = Helpers.getPDPJumpId(product, jumpInfo);
    let isParentPrd = product.prdClass === 'PRT';
    let productUrl = Helpers.addUrlParam(
        `/pdp/${product.slug}`,
        urlParams
    );
    return (
        <div className={`product-card-new${className ? ' ' + className : ''}`} data-sku={product.sku} {...otherProps}>
            <ProductJsonLd product={product} />
            { bundleComponents && <ProductCardBundle bundle={bundleComponents} />}
            <ProductCardHeader product={product} productIndex={productIndex} saleCalloutPath={saleCalloutPath} />
            <ProductCardDetail
                product={product}
                productIndex={productIndex}
                productUrl={productUrl}
                hideMktDiff={hideMktDiff}
                displayAvgRating={true}
                productClickMetrics={productClickMetrics}
            />
            <ProductCardFooter
                product={product}
                link={metadata.ctaLink}
                text={metadata.ctaText}
                jumpId={urlParams.jumpid}
                productUrl={productUrl}
                ctaMetrics={ctaMetrics}
                popupConfig={popupConfig}
                productClickMetrics={productClickMetrics}
                baseProductSku={baseProductSku}
                xsellType={xsellType}
                templateKey={templateKey}
            />
        </div>
    );
}

ProductCard.defaultProps = {
    className: '',
    hideMktDiff: false
};

export default withError(React.memo(ProductCard));